import React from "react";

/**
 * Custom row for react-mentions @ dropdown (used via Mention renderSuggestion).
 */
export function renderMentionSuggestion(
  suggestion,
  search,
  highlightedDisplay,
  index,
  focused,
) {
  const email =
    suggestion?.display ||
    (typeof highlightedDisplay === "string" ? highlightedDisplay : "");

  return (
    <div
      className={`mention-suggestion-item${focused ? " mention-suggestion-item--focused" : ""}`}
      role="option"
      aria-selected={focused}
    >
      <span className="mention-suggestion-item__badge" aria-hidden>
        @
      </span>
      <span className="mention-suggestion-item__email">
        {highlightedDisplay || email}
      </span>
    </div>
  );
}
